
import {
  defineComponent,
  onBeforeMount,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";
import AppConst from "@/consts/app-const";

export default defineComponent({
  name: "Post",
  components: {
    CancelButton,
    Header,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toEdit = () => router.push({ name: "edit" });

    const { imageEditor } = useGlobalStore();
    const editCompletedImage = imageEditor.editCompletedImage;
    const uploadedImageId = imageEditor.uploadedImageId as string;
    if (!editCompletedImage || !uploadedImageId) {
      toSelect();
      return;
    }
    const postImgSrc = editCompletedImage; // DataURL形式の文字列

    const sns = reactive({
      url: "",
      title: "%23" + AppConst.APP_NAME + "で自分だけの %23家紋 を作ろう！",
      body: "こんな家紋ができました〜↓↓",
      hashtags: AppConst.APP_HASHTAG_EN,
    });

    onBeforeMount(() => {
      setShareUrl(uploadedImageId);
    });

    onMounted(() => {});

    onUnmounted(() => {});

    function setShareUrl(imageId: string) {
      sns.url = process.env.VUE_APP_URL + "result/" + imageId;
    }

    function onClickTweetBtn() {
      let shareURL = "https://twitter.com/intent/tweet";
      shareURL += "?text=" + sns.title + "%0a" + sns.body;
      shareURL += "&hashtags=" + sns.hashtags;
      shareURL += "&url=" + sns.url;

      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(shareURL, "twitter", option);
    }

    return {
      toEdit,
      postImgSrc,
      onClickTweetBtn,
    };
  },
});
